export enum TableTennisGameType {
    RALLY = "RALLY"
}
export enum TableTennisGameFormat {
    WIN_BY_2 = "WIN_BY_2"
}